const LOCAL_API_BASE_URL = "http://127.0.0.1:8000";

// -------------------------------------------------------------------------------------------------------
// 1. API URL BUILDER

export const getApiUrl = (path) => {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  if (process.env.NODE_ENV === "development") {
    return `${LOCAL_API_BASE_URL}${cleanPath}`;
  }

  return cleanPath;
};